import React from 'react'
import Modal from 'react-modal'
import cn from 'classnames'
import { X } from 'lucide-react'
import StreamInvite from 'components/teams/StreamInvite'
import { isMobile } from 'lib/device'
import styles from 'components/teams/stream-join-modal.module.scss'

Modal.setAppElement('#knovigator-body')

export default function StreamJoinModal({
    isOpen,
    team,
    onDismiss,
    onJoined,
    reason = null,
    readFirstLabel = 'Read it first',
}) {
    if (!team?.id) return null
    const isMobileSurface =
        isMobile || (typeof window !== 'undefined' && Boolean(window.KNOVIGATOR_IS_MOBILE))

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onDismiss}
            className={cn(styles.modal, isMobileSurface && styles.mobileSurface)}
            overlayClassName={cn(styles.overlay, isMobileSurface && styles.mobileSurface)}
            contentLabel={`Join ${team.name || 'channel'}`}
        >
            <div className={styles.content} data-testid="stream-join-modal">
                <button
                    type="button"
                    className={styles.closeButton}
                    aria-label="Close channel invite"
                    data-testid="stream-join-modal-close"
                    onClick={onDismiss}
                >
                    <X size={20} />
                </button>
                <StreamInvite
                    streamId={team.id}
                    presentation="modal"
                    onJoined={onJoined}
                    onReadFirst={onDismiss}
                    reason={reason}
                    readFirstLabel={readFirstLabel}
                />
            </div>
        </Modal>
    )
}
